import { ListingOfferCardHorizontal } from 'app/components/listing-card-horizontal.large';
import type { ListingOfferCardProps } from 'app/types/listing-offer-card-props';

export function ManagementOfferCard(props: ListingOfferCardProps) {
  return <ListingOfferCardHorizontal {...props} horizontalVariant="management" />;
}
